<template>
    <form
        v-if="form"
        id="form"
        class="form basic-form bucket-list-form"
        autocomplete="off"
        novalidate
        @submit="emitSubmit"
    >
        <!-- privacy -->
        <div v-if="false" class="form-field">
            <label for="privacy" class="required">Who can see this?</label>
            <EnumRadio v-model="form.privacy.value" group="privacy" />
            <FormError :errors="errors.privacy" />
        </div>

        <!-- type -->
        <div v-if="!edit" class="form-field">
            <label for="type" class="required">Bucket list type:</label>
            <select
                id="type"
                v-model="form.type.value"
                @change="updateTemplates"
            >
                <EnumOptions group="bucket_list_type" />
            </select>
            <small v-if="form.type.value === 'country'">
                Items from all country bucket lists will appear in the homepage
                map.
            </small>
            <small v-if="form.type.value === 'region'">
                Sometimes, you're only interested in particular regions in a
                country, like US states, UK's countries or Portuguese
                archipelagos.
            </small>
            <small v-if="form.type.value === 'city'">
                Any city, town or village can be added to a city bucket list.
            </small>
            <small v-if="form.type.value === 'place'">
                Place items can be any locations on the map - islands, museums,
                sites, addresses, cities or countries. Places don't need to be
                unique, so you can make a place bucket list of anything at any
                location - cuisine, experiences, hikes, scuba dives ...
            </small>
            <small v-if="form.type.value === 'custom'">
                Use custom bucket lists for any type of item that doesn't need
                location tracking. It can be food, things to see, things to do.
                If you do want to track location with such items, set the type
                to Place.
            </small>
            <FormError :errors="errors.type" />
        </div>

        <!-- name -->
        <div class="form-field">
            <label for="name" class="required">Name:</label>
            <input
                id="name"
                v-model="form.name.value"
                :placeholder="nameSuggestion"
                type="text"
                maxlength="100"
            />
            <FormError :errors="errors.name" />
        </div>

        <!-- template -->
        <div v-if="availableTemplates.length" class="form-field">
            <label for="template_name">Template:</label>
            <select id="template_name" v-model="form.template_name.value">
                <option :value="null">None</option>
                <option
                    v-for="template in availableTemplates"
                    :key="template.name"
                    :value="template.name"
                >
                    {{ template.name }}
                </option>
            </select>
            <small>
                Optionally, you can pre-add items to your bucket list. You can
                always remove the ones you don't want to keep.
            </small>
            <FormError :errors="errors.template_name" />
        </div>

        <div class="actions">
            <div v-if="deletePending" class="confirmation">
                Are you sure you want to delete this bucket list?
            </div>
            <Bttn v-if="!deletePending" id="submit-bucket-list" type="submit">
                Save
            </Bttn>
            <Bttn
                v-if="canDelete && !deletePending"
                class="outlined"
                @click="deletePending = true"
            >
                Delete
            </Bttn>
            <Bttn
                v-if="deletePending"
                class="outlined"
                @click="deletePending = false"
            >
                Cancel
            </Bttn>
            <Bttn v-if="deletePending" @click="emitDelete">Confirm</Bttn>
            <router-link v-if="!deletePending" :to="backLink">
                <Bttn class="outlined">Back</Bttn>
            </router-link>
        </div>
    </form>
</template>

<script>
import BaseForm from "js/components/base/BaseForm.js";
import EnumOptions from "js/components/forms/EnumOptions";
import EnumRadio from "js/components/forms/EnumRadio";
import FormError from "js/components/forms/FormError";

const nameSuggestions = {
    country: "Countries I want to visit",
    region: "Italian regions I want to visit",
    city: "Capitals I want to visit",
    place: "Must see attractions",
    custom: "Famous dishes to try",
};

export default {
    name: "BucketListForm",
    components: { FormError, EnumRadio, EnumOptions },
    extends: BaseForm,
    props: {
        edit: {
            type: Boolean,
            default: false,
        },
        templates: {
            type: Array,
            default: null,
        },
    },
    data() {
        return {
            availableTemplates: [],
            form: {
                name: {
                    value: null,
                },
                type: {
                    value: null,
                    skip: () => this.edit,
                },
                privacy: {
                    value: "personal",
                },
                template_name: {
                    value: null,
                },
            },
        };
    },
    computed: {
        nameSuggestion() {
            if (this.form.type.value === null) {
                return;
            }
            return nameSuggestions[this.form.type.value];
        },
    },
    methods: {
        updateTemplates() {
            if (!this.templates || !this.form.type.value) {
                this.availableTemplates = [];
                return;
            }
            this.availableTemplates = this.templates.filter((template) => {
                return template.bucket_list_type == this.form.type.value;
            });
        },
    },
};
</script>
